import { render, staticRenderFns } from "./TabsDashboardProviderRequests.vue?vue&type=template&id=bd8343a2&"
import script from "./TabsDashboardProviderRequests.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardProviderRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports